var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { background: "#17171a" } },
    [
      _c("SiteHead"),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("div", { staticClass: "verification-main" }, [
            _c("div", { staticClass: "verification-main-header" }, [
              _c(
                "svg",
                { staticClass: "icon", attrs: { "aria-hidden": "true" } },
                [_c("use", { attrs: { "xlink:href": "#icon-daiwenzilogo" } })]
              ),
              _vm._v(" "),
              _c("h1", { staticClass: "bold" }, [
                _vm._v(_vm._s(_vm.$t("8100013")))
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "verification-main-search flex-between" },
              [
                _c("i", { staticClass: "iconfont icon-search bold" }),
                _vm._v(" \n        "),
                _c("van-field", {
                  attrs: {
                    type: "text",
                    placeholder: _vm.$t("8100014"),
                    maxlength: "150",
                    clearable: ""
                  },
                  model: {
                    value: _vm.keyWord,
                    callback: function($$v) {
                      _vm.keyWord = $$v
                    },
                    expression: "keyWord"
                  }
                }),
                _vm._v(" "),
                _c(
                  "van-button",
                  {
                    staticClass: "form-btn",
                    attrs: {
                      loading: _vm.buttonLoading,
                      disabled: _vm.keyWord === ""
                    },
                    on: { click: _vm.handleCheck }
                  },
                  [_vm._v(_vm._s(_vm.$t("300143")))]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "verification-main-content" }, [
              _c("p", { staticClass: "bold title" }, [
                _vm._v(_vm._s(_vm.$t("8100015")))
              ]),
              _vm._v(" "),
              _c("ul", { attrs: { type: "none" } }, [
                _c("li", [
                  _c(
                    "svg",
                    { staticClass: "icon", attrs: { "aria-hidden": "true" } },
                    [
                      _c("use", {
                        attrs: { "xlink:href": "#icon-a-material_1svg" }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "content-text" }, [
                    _c("p", { staticClass: "bold" }, [
                      _vm._v(_vm._s(_vm.$t("300144")))
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "block" }, [
                      _vm._v(_vm._s(_vm.$t("8100016")))
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("li", [
                  _c(
                    "svg",
                    { staticClass: "icon", attrs: { "aria-hidden": "true" } },
                    [
                      _c("use", {
                        attrs: { "xlink:href": "#icon-a-material_2svg" }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "content-text" }, [
                    _c("p", { staticClass: "bold" }, [
                      _vm._v(_vm._s(_vm.$t("8100017")))
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "block" }, [
                      _vm._v(_vm._s(_vm.$t("8100018")))
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("li", [
                  _c(
                    "svg",
                    { staticClass: "icon", attrs: { "aria-hidden": "true" } },
                    [
                      _c("use", {
                        attrs: { "xlink:href": "#icon-a-material_3svgfill" }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "content-text" }, [
                    _c("p", { staticClass: "bold" }, [
                      _vm._v(_vm._s(_vm.$t("8100019")))
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "block" }, [
                      _vm._v(_vm._s(_vm.$t("8100020")))
                    ])
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("p", {
              staticClass: "verification-main-tips",
              domProps: { innerHTML: _vm._s(_vm.$t("8100021")) }
            })
          ]),
          _vm._v(" "),
          _c("SiteMap")
        ],
        1
      ),
      _vm._v(" "),
      _c("SiteFoot"),
      _vm._v(" "),
      _c(
        "van-popup",
        {
          model: {
            value: _vm.resultModel,
            callback: function($$v) {
              _vm.resultModel = $$v
            },
            expression: "resultModel"
          }
        },
        [
          _vm.resultObj
            ? _c(
                "div",
                { staticClass: "result-model" },
                [
                  _c("p", { staticClass: "bold model-title flex-center" }, [
                    _c(
                      "svg",
                      { staticClass: "icon", attrs: { "aria-hidden": "true" } },
                      [
                        _c("use", {
                          attrs: {
                            "xlink:href":
                              _vm.resultObj.code != 200
                                ? "#icon-shibai1"
                                : "#icon-chenggong"
                          }
                        })
                      ]
                    ),
                    _vm._v(
                      "  " +
                        _vm._s(
                          _vm.resultObj.code != 200
                            ? _vm.$t("8100022")
                            : _vm.$t("8100023")
                        )
                    )
                  ]),
                  _vm._v(" "),
                  _vm.resultObj.code != 200
                    ? _c("span", {
                        staticClass: "block model-res-message",
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$t("8100024", { keyWord: _vm.keyWord })
                          )
                        }
                      })
                    : _c("span", {
                        staticClass: "block model-res-message",
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$t("8100025", {
                              keyWord: _vm.keyWord,
                              note: _vm.resultObj.data
                            })
                          )
                        }
                      }),
                  _vm._v(" "),
                  _c("div", { staticClass: "safety-tips" }, [
                    _c("p", [
                      _c("i", { staticClass: "iconfont icon-tishi" }),
                      _vm._v("  " + _vm._s(_vm.$t("8100026")))
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "block" }, [
                      _vm._v(_vm._s(_vm.$t("8100027")))
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "block" }, [
                      _vm._v(_vm._s(_vm.$t("8100028")))
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "block" }, [
                      _vm._v(_vm._s(_vm.$t("8100029")))
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "van-button",
                    {
                      staticClass: "form-btn",
                      on: {
                        click: function($event) {
                          _vm.resultModel = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("10000018")))]
                  )
                ],
                1
              )
            : _vm._e()
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ccec0788", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ccec0788","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/verification.vue
// module id = rMG3
// module chunks = 0